import { create } from 'zustand';

type ScrollableDialog = {
  isOpen?: boolean;
  title: string;
  contentText?: string;
  onConfirm?: (() => Promise<void>) | (() => void);
  onClose?: () => void;
  contentNode?: React.ReactNode;

  cancelTextBtn?: string;
  confirmTextBtn?: string;
};

const scrollableDialogInitialState: ScrollableDialog = {
  isOpen: false,
  title: '',
  contentText: '',
  contentNode: null,
  cancelTextBtn: 'Cerrar',
  confirmTextBtn: 'Confirmar',
  onConfirm: () => {},
  onClose: () => {},
};

interface ScrollableDialogState {
  scrollableDialog: ScrollableDialog;
  scrollableDialogKey: string;

  setScrollableDialog: (dialog: ScrollableDialog) => void;
  closeScrollableDialog: () => void;
  setScrollableDialogKey: (key: string) => void;
}

export const useScrollableDialogStore = create<ScrollableDialogState>(
  (set, get) => ({
    scrollableDialog: scrollableDialogInitialState,
    scrollableDialogKey: 'someInitialKey',

    setScrollableDialog: dialog =>
      set({ scrollableDialog: { ...dialog, isOpen: true } }),

    closeScrollableDialog: () => {
      set({
        scrollableDialog: {
          ...get().scrollableDialog,
          isOpen: false,
        },
      });
    },

    setScrollableDialogKey: key => set({ scrollableDialogKey: key }),
  })
);
